import React from 'react'
import Profile from '../../Components/Patient/Profile/Profile'

const PatientProfilePage = () => {
  return (
    <div><Profile /></div>
  )
}

export default PatientProfilePage